export const passwordRegEx = /^(?=.{8,250})(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/;
export const numberRegEx = /^[0-9]+$/;
export const readContactPermissionRegEx =
  /^contacts:[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}:read$/;
